var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "activity-stage"
  }, [_c('div', {
    style: _vm.stageStyle,
    attrs: {
      "id": "curtain"
    }
  }, [_c('div', {
    attrs: {
      "id": "stage"
    }
  }, [_vm._l(_vm.currentRound.musicians, function (musician, index) {
    return _c('figure', {
      key: ("musician" + index)
    }, [_c('figcaption', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: musician.name,
        expression: "musician.name"
      }],
      domProps: {
        "textContent": _vm._s(musician.name)
      }
    }), _c('img', {
      attrs: {
        "src": musician.img,
        "alt": "musician"
      }
    })]);
  }), _c('figure', [_c('figcaption', {
    attrs: {
      "id": "primary"
    }
  }, [_vm._v("Primary")]), _vm.completed && _vm.currentRound.primary ? _c('img', {
    attrs: {
      "id": "color",
      "src": _vm.currentRound.primary.color,
      "alt": "musician"
    }
  }) : _vm._e(), !_vm.completed && _vm.currentRound.primary ? _c('img', {
    attrs: {
      "id": "bw",
      "src": _vm.currentRound.primary.img,
      "alt": "musician"
    }
  }) : _vm._e()]), _c('div', {
    attrs: {
      "id": "dialog"
    }
  }, [_c('text-display-list', {
    attrs: {
      "id": "input",
      "text-size": "small"
    }
  }, _vm._l(_vm.currentRound.steps, function (step) {
    return _c('blinking-cursor-text', {
      key: ("step" + (step.stepIndex)),
      attrs: {
        "text": step.answer,
        "text-step": step.stepIndex
      }
    });
  }), 1)], 1)], 2)]), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }